export interface IChangeCalculationOptions {
  current: number;
  previous: number;
  increaseGood: boolean;
}

/**
 * Calculates change metrics between two values.
 * Handles difference, percentage, and determines if change is "good" based on increaseGood flag.
 *
 * @param options - Current value, previous value, and whether increase is considered good
 * @returns Change calculation result with raw difference number, formatted percentage, and good/bad flag
 */
export function calculateChange({ current, previous, increaseGood }: IChangeCalculationOptions) {
  const difference = current - previous;
  const isIncrease = current > previous;
  const isZeroChange = current === previous;

  // Don't show percentage if either value is negative (confusing)
  const percentageChange = previous === 0 || current < 0 || previous < 0 ? undefined : (difference / previous) * 100;

  const percentage =
    percentageChange !== undefined
      ? `${percentageChange < 0 ? '-' : ''}${Math.abs(percentageChange).toFixed(1)}%`
      : undefined;

  // Zero change is always considered good (green)
  // If increaseGood is true: increase = success (green), decrease = error (red)
  // If increaseGood is false: increase = error (red), decrease = success (green)
  const isGoodChange = isZeroChange ? true : increaseGood ? isIncrease : !isIncrease;

  return {
    difference,
    percentage,
    isGoodChange,
    isIncrease,
    isZeroChange,
  };
}
